import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Spin } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, userSelector, clearState } from "../../../features/authSlice";


const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSuccess, isError, errorMessage, isFetching, role } = useSelector(userSelector);

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      const isAdmin = ['user', 'admin'].includes(role);
      navigate(isAdmin ? "/admin" : "/portal");
    }
  }, [isSuccess, role, navigate]);

  const onFinish = (values) => {
    dispatch(loginUser(values));
  };

  const token = localStorage.getItem("token");
  if (isFetching && token) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
    }}>
      {/* Sección izquierda - Imagen y texto */}
      <div style={{
        flex: 1,
        background: "linear-gradient(135deg, #1d3557 0%, #457b9d 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        color: "white",
        textAlign: "center",
      }}>
        <div style={{
          maxWidth: 400,
          marginBottom: "2rem",
        }}>
          <h1 style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "white",
          }}>
            Servicios Notariales Digitales
          </h1>
          <p style={{
            fontSize: "1.2rem",
            opacity: 0.9,
            lineHeight: 1.6,
          }}>
            Modernizamos los servicios notariales con tecnología de vanguardia para brindarte seguridad, eficiencia y confianza en cada procedimiento.
          </p>
        </div>
        
        {/* Ilustración placeholder */}
        
      </div>

      {/* Sección derecha - Formulario */}
      <div style={{
        flex: 1,
        background: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
      }}>
        <div style={{
          maxWidth: 400,
          width: "100%",
        }}>
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <img
              src="/logo.png"
              alt="Digital Notary Logo"
              style={{ width: 180, height: 80, objectFit: "contain", marginBottom: "1rem" }}
            />
            <h2 style={{ 
              color: "#1d3557", 
              fontSize: "1.8rem",
              fontWeight: "600",
              margin: 0,
            }}>
              → Inicia sesión
            </h2>
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            size="large"
          >
            <Form.Item
              label="Email*"
              name="email"
              rules={[
                { required: true, message: "Por favor ingresa tu email!" },
                { type: "email", message: "Por favor ingresa un email válido!" },
              ]}
            >
              <Input placeholder="Ingrese Email" />
            </Form.Item>

            <Form.Item
              label="Contraseña*"
              name="password"
              rules={[
                { required: true, message: "Por favor ingresa tu contraseña!" },
              ]}
            >
              <Input.Password placeholder="Ingrese Contraseña" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ 
                  width: "100%",
                  height: "45px",
                  fontSize: "1rem",
                  backgroundColor: "#666",
                  borderColor: "#666",
                }}
                loading={isFetching}
              >
                Ingresar
              </Button>
            </Form.Item>

            {isError && (
              <div style={{ 
                color: "#ff4d4f", 
                textAlign: "center", 
                marginTop: "1rem",
                padding: "0.5rem",
                backgroundColor: "#fff2f0",
                borderRadius: "4px",
                border: "1px solid #ffccc7",
              }}>
                {errorMessage || "Error al iniciar sesión"}
              </div>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;